import { Dispatch, SetStateAction } from "react";
import { User } from "../UserManagement";

export enum FormAccess {
  VIEW = "View",
  EDIT = "Edit",
  CREATE = "Create",
  DELETE = "Delete",
}

export enum ProductStatus {
  PENDING = "pending",
  DENIED = "denied",
  ADVANCED_PAYMENT_LINK_SENT = "Pending Advance Payment",
  ADVANCED_PAYMENT_CONFIRM = "Advanced Payment Confirmed",
  DENIED_ADVANCED_PAYMENT = "Advanced Payment Denied",
  PENDING_BALANCED_PAYMENT = "Pending Balance Payment",
  BALANCE_PAYMENT_CONFIRM = "Blanace Payment Confirmed",
  BALANCE_PAYMENT_DENIED = "Balance Payment Denied",
  COMPLETE = "Complete",
  CANCELLED = "Cancelled",
  NEW = "new",
}

export type Product = {
  id: string;
  product: string;
  price: string;
  rentalStartDate: Date;
  rentalEndDate: Date;
  deliveryMethod: string;
  registeredUser: boolean;
  message: string;
  userId: string;
  user: User;
  status: ProductStatus;
  productType: ProductType;

  //user data
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  suburb: string;
  vicPostalCode: string;
  state: string;
};

export type ProductType = {
  id: string;
  name: string;
  price: string;
};

export type ProductModalDetailsType = {
  id: string | undefined;
  type: FormAccess;
};

export type ProductRowType = Product & {
  setCentered?: Dispatch<SetStateAction<boolean>>;
  modalDetails?: Dispatch<SetStateAction<ProductModalDetailsType | undefined>>;
};

export type GetRequestsRenseponse = {
  data: Product[];
  error: string;
};
